import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-eight',
  templateUrl: './c1-one-one-one-eight.component.html',
  styleUrls: ['./c1-one-one-one-eight.component.scss']
})
export class C1OneOneOneEightComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.8_HOUSE EXAM._DATE SHEET _2021-22.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
